var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56.7,
    height: 56.7,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      vectorEffect: "non-scaling-stroke"
    },
    stroke: "null",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("title", {
    stroke: "null"
  }, "background"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_4"
  }, /*#__PURE__*/React.createElement("title", {
    fill: "#707070",
    stroke: "null"
  }, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    stroke: "null",
    id: "svg_2",
    d: "m39.523231,23.948426c-3.160105,0 -4.175854,3.047244 -4.401575,4.853019l0,0.112861l-0.451444,1.692914c1.354331,1.128609 3.047244,1.918635 4.740158,1.918635c2.257218,0 4.288714,-1.918635 4.401575,-4.401575c0,-2.257218 -1.918635,-4.175854 -4.288714,-4.175854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    stroke: "null",
    id: "svg_3",
    d: "m28.350001,0.360496c-15.461944,0 -27.989505,12.527561 -27.989505,27.989505c0,15.461944 12.527561,27.989505 27.989505,27.989505c15.461944,0 27.989505,-12.527561 27.989505,-27.989505c0,-15.461944 -12.527561,-27.989505 -27.989505,-27.989505zm11.17323,36.566934c-2.257218,0 -4.175854,-0.677165 -5.868767,-1.692914l-1.918635,9.028872l-4.401575,0l2.708662,-12.4147c-1.128609,-1.580053 -2.257218,-3.385827 -3.047244,-5.078741l0,1.918635c0,4.627297 -3.72441,8.351707 -8.238846,8.351707c-4.514436,0 -8.238846,-3.72441 -8.238846,-8.351707l0,-11.286091l4.288714,0l0,11.286091c0,2.257218 1.805774,4.062993 4.062993,4.062993c2.257218,0 4.062993,-1.805774 4.062993,-4.062993l0,-11.286091l4.288714,0c0.902887,2.821523 2.370079,6.20735 4.288714,9.254594c1.128609,-4.288714 4.288714,-6.884515 8.238846,-6.884515c4.627297,0 8.464568,3.837271 8.464568,8.464568c-0.225722,4.853019 -4.062993,8.69029 -8.69029,8.69029z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwork);
export default __webpack_public_path__ + "static/media/upwork.15545291c76e77f5217118b95007e008.svg";
export { ForwardRef as ReactComponent };